var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSingleCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 14,
  viewBox: "0 0 18 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.00002 11.2L1.80002 6.99998L0.400025 8.39998L6.00002 14L18 1.99998L16.6 0.599975L6.00002 11.2Z",
  fill: "#02CA79"
})));
export { SvgSingleCheck as ReactComponent };
export default __webpack_public_path__ + "fe2717f977e1f79f7080e9bb26d4c42a.svg";